import {ActionType} from 'typesafe-actions';
import * as actions from './actions';
import * as sharedActions from '../shared/actions';
import {LocalLanguageType, Paged, RequestStatus, SortDirection} from '../shared/types';
import {DateRangeWithServiceProvidersAndSoldTosAndLanguageRequest} from '../analytics';

export enum JobsActionTypes {
    GET_JOBS_REQUEST = '@@jobs/GET_JOBS_REQUEST',
    GET_JOBS_SUCCESS = '@@jobs/GET_JOBS_SUCCESS',
    GET_JOBS_FAILURE = '@@jobs/GET_JOBS_FAILURE',

    GET_TIRE_SERVICE_REQUEST = '@@jobs/GET_TIRE_SERVICE_REQUEST',
    GET_TIRE_SERVICE_SUCCESS = '@@jobs/GET_TIRE_SERVICE_SUCCESS',
    GET_TIRE_SERVICE_FAILURE = '@@jobs/GET_TIRE_SERVICE_FAILURE',
}

export type JobsAction = ActionType<typeof actions> | ActionType<typeof sharedActions>;

export interface JobsState {
    readonly jobs?: Paged<Job>;
    readonly jobsRequestStatus?: RequestStatus;

    readonly tireService?: TireServiceDetails;
    readonly tireServiceRequestStatus?: RequestStatus;
}

export interface JobContract {
    id: string;
    startDate: string;
    endDate: string;
    isEjob: boolean;
    ejobId:string;
    ejobUser:string;
    vehicleId: string;
    jobType: JobType;
    serviceProviderId: string;
    serviceProviderName: string;
    purchasingDocumentId: string;
    licensePlate: string;
    purchasingRef: string;
    jobReference: string;
    fleetName: string;
}

export interface Job {
    id: string;
    startDate: Date;
    endDate: Date;
    isEjob: boolean;
    ejobId:string;
    ejobUser:string;
    vehicleId: string;
    jobType: JobType;
    serviceProviderId: string;
    serviceProviderName: string;
    licensePlate: string;
    jobReference: string;
    fleetName: string;
}

export interface JobsExplorerRequest extends DateRangeWithServiceProvidersAndSoldTosAndLanguageRequest {
    page: number;
    itemsPerPage: number;
    sort: JobsSort;
    serviceProviderNameContains?: string;
    licensePlateContains?: string;
    jobReferenceContains?: string;
    inspectionTypeContains?: string;
    fleetReferenceContains?: string;
    fleetNameContains?: string;
    ejobUserContains?: string;
    jobTypeExcludedOptions?:JobType[];
    isEjobExcludedOptions?:boolean[];
}

export interface TireServiceDetailsRequest {
    jobId: string;
    serviceProviderGroupId:string;
    language:LocalLanguageType
}

export enum JobType {
    Breakdown = 'Breakdown Service',
    Regular = 'Regular Service',
}

export enum InspectionType {
    Scheduled = 'scheduled',
    Unscheduled = 'unscheduled',
}

export enum JobCategory {
    FOS = 'fos',
    Ejob = 'ejob',
}

export interface JobsSort {
    column: JobsSortColumn;
    direction: SortDirection;
}

export enum JobsSortColumn {
    None = 'none',
    Date = 'date',
    JobReference = 'jobReference',
    IsEjob = 'isEjob',
    EjobUser = 'ejobUser',
    JobType = 'jobType',
    LicensePlate = 'licensePlate',
    ServiceProviderName = 'serviceProviderName',
    PurchasingRef = 'purchasingReference',
    FleetName = 'fleetName',
}

export interface TireServiceDetails {
    reference: string;
    vehicleId:string;
    licensePlate: string;
    odometerReading: string;
    serviceProvider: string;
    jobType: JobType;
    jobDate: string;
    isEjob: boolean;
    ejobId:string;
    hasAttachments:boolean;
    taskList: TaskList[];
    damageDetails: DamageDetail[];
}

export interface TaskList {
    axle: string;
    wheel: string;
    description: string;
    serialNumber: string;
    taskReason: string;
    treadDepth: number;
    pressureInitial: number;
    pressureAdjust: number;
}

export interface DamageDetail {
    serialNumber: string;
    damageArea: string;
    damageType: string;
    treadDepth: number;
}

export interface EjobSheet {
    available: boolean;
    data: string;
}

export interface JobAttachments {
    available: boolean;
    data: JobAttachmentData;
}

export interface JobAttachmentData{
    documents: JobAttachmentDocument[];
}

export interface JobAttachmentDocument {
    name: string;
    base64Content: string;
}

export interface JobSummaryAttachments {
    available: boolean;
    data: string;
}
